/*
 * DK Dolls Kill tarzi hizli ekle.
 * Beden secimi UI'sini yonetir; sepete ekleme Dawn'in mevcut <product-form> +
 * product-form.js altyapisi tarafindan yapilir (AJAX + cart-notification).
 */
if (!customElements.get('dk-quick-add')) {
  customElements.define(
    'dk-quick-add',
    class DKQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.toggle = this.querySelector('.dk-quick__toggle');
        this.panel = this.querySelector('.dk-quick__panel');
        this.closeBtn = this.querySelector('.dk-quick__close');
        this.variantInput = this.querySelector('.dk-quick__variant-id');
        this.addBtn = this.querySelector('.dk-quick__add');
        this.sizeBtns = Array.from(this.querySelectorAll('.dk-quick__size'));

        if (this.toggle) {
          this.toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
          });
        }

        this.sizeBtns.forEach((btn) => {
          if (btn.hasAttribute('disabled')) return;
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.selectSize(btn);
          });
        });

        // Tek uygun beden varsa otomatik sec (kullanici tek tikla ekleyebilsin)
        const available = this.sizeBtns.filter((b) => !b.hasAttribute('disabled'));
        if (this.sizeBtns.length && available.length === 1) {
          this.selectSize(available[0]);
        }

        // Panel disina tiklayinca kapat
        this._onDocClick = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        document.addEventListener('click', this._onDocClick);
      }

      disconnectedCallback() {
        if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      }

      open() {
        if (!this.panel) return;
        this.panel.hidden = false;
        this.classList.add('dk-quick--open');
        if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (!this.panel) return;
        this.panel.hidden = true;
        this.classList.remove('dk-quick--open');
        if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
      }

      selectSize(btn) {
        this.sizeBtns.forEach((b) => b.classList.remove('dk-quick__size--selected'));
        btn.classList.add('dk-quick__size--selected');
        if (this.variantInput) this.variantInput.value = btn.dataset.variantId;
        if (this.addBtn) this.addBtn.removeAttribute('disabled');
      }
    }
  );
}
